import * as React from 'react'

type propsType = {
  stroke?: string
  fill?: string
}

export const Plus = (props: propsType) => (
  <svg width={14} height={15} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 13.8A6.3 6.3 0 1 0 7 1.2a6.3 6.3 0 0 0 0 12.6Z"
      fill={props.fill ? props.fill : '#FFFFFF'}
      stroke={props.stroke ? props.stroke : 'rgba(225, 36, 104, 1)'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 4.8v5.4M4.3 7.5h5.4"
      stroke={props.stroke ? props.stroke : 'rgba(225, 36, 104, 1)'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
